import { containerNames, frameNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { iframeService } from '../../services/iframeService';
import {
  GameOpenInfoStyles,
  LostConnectionInfoStyles,
  ReconnectInfoStyles,
} from '../../core/constants/popupTypes';
import { gameStore } from '../../store/gameStore';
import { gameEvents } from '../../lib/gameEvents';
import { spinBarStore } from '../../store/spinBarStore';
import { isMobile } from '../../helpers/isMobile';
import { MAX_USER_INACTIVE_STATE_DURATION } from '../../core/constants';

export class PopupDrawer {
  constructor() {
    this.animations = {};
    this.PopupContainer = PixiBase.createContainer(containerNames.PopupContainer);
    this.isLowBalance = false;
    this.isOpenPopup = false;
    this.visibilityStartTime = Date.now();
  }

  createPopupBackGroundGraphics() {
    const connectionPopupGraphics = PixiBase.createGraphics();
    this.connectionPopupGraphics = connectionPopupGraphics;
    connectionPopupGraphics.beginFill('black');
    connectionPopupGraphics.alpha = 0.6;
    connectionPopupGraphics.drawRect(0, 0, isMobile() ? 540 : 1950, isMobile() ? 960 : 1000);
    connectionPopupGraphics.endFill();
    connectionPopupGraphics.interactive = true;
    this.connectionPopup.addChild(connectionPopupGraphics);
    return connectionPopupGraphics;
  }

  createPopupInfoImg() {
    const connectionPopupImg = PixiBase.createSprite(this.spriteSheet.reconnect);
    this.connectionPopupImg = connectionPopupImg;
    const { x, y, anchor } = this.config.ConnectionPopupContainer.reconnectIcon;
    PixiBase.setPosition(connectionPopupImg, { x, y });
    connectionPopupImg.anchor.set(anchor);
    // connectionPopupImg.scale.set(1.5);
    this.connectionPopup.addChild(connectionPopupImg);
    return connectionPopupImg;
  }

  createPopupBackGround() {
    this.connectionPopup = PixiBase.createContainer(containerNames.ConnectionPopup);
    const connectionPopupTexture = PixiBase.createSprite(this.spriteSheet.connectionPopup);
    this.connectionPopupTexture = connectionPopupTexture;
    const { x, y, anchor } = this.config.ConnectionPopupContainer.connectionPopupConfig;
    PixiBase.setPosition(connectionPopupTexture, { x, y });
    this.connectionPopupTexture.anchor.set(anchor);

    this.connectionPopup.addChild(connectionPopupTexture);
    this.PopupContainer.addChild(this.connectionPopup);
    this.PopupContainer.visible = false;
  }

  createPopupInfoText() {
    const popupInfoText = PixiBase.createText('Please wait', {
      fontSize: 18,
      fill: ['#FFFFFF'],
      align: 'center',
      fontWeight: 400,
      fontFamily: 'Poppins',
      wordWrap: true,
      wordWrapWidth: 320,
    });
    const popupInfoText2 = PixiBase.createText(gameStore.canvasTranslationKeys.RECONNECTING, {
      fontSize: 18,
      fill: ['#FFFFFF'],
      align: 'center',
      fontWeight: 400,
      fontFamily: 'Poppins',
      wordWrap: true,
      wordWrapWidth: 320,
    });
    this.popupInfoText = popupInfoText;
    this.popupInfoText2 = popupInfoText2;
    const { x, y, anchor } = this.config.ConnectionPopupContainer.popupInfoText;
    PixiBase.setPosition(popupInfoText, { x, y });
    PixiBase.setPosition(popupInfoText2, { x, y: y + 15 });
    this.popupInfoText.anchor.set(anchor);
    this.popupInfoText2.anchor.set(anchor);
    this.popupInfoText.visible = false;
    this.popupInfoText2.visible = false;
    this.connectionPopup.addChild(popupInfoText);
    // this.connectionPopup.addChild(popupInfoText2);
  }

  createPopupOkButton() {
    const popupOkButton = PixiBase.createSprite(this.spriteSheet.refreshButton);
    const popupButtonText = PixiBase.createText(gameStore.canvasTranslationKeys.OK, {
      fontSize: 18,
      fill: 'black',
      align: 'center',
      fontWeight: 400,
      fontFamily: 'Roboto',
    });
    this.popupButtonText = popupButtonText;
    this.popupOkButton = popupOkButton;
    popupOkButton.visible = false;
    PixiBase.setupButtonMode(popupOkButton, { interactive: true, buttonMode: true });
    PixiBase.registerClick(popupOkButton, () => {
      if (!this.isLowBalance) {
        iframeService.redirectHome();
        this.isLowBalance = false;
      } else {
        gameStore.setGameResultMatrix(gameStore.noWinMatrix);
        gameEvents.emit('stopColumnsSequentially');
        spinBarStore.setIsAutoBetStart(false);
        spinBarStore.setSelectedAutoBetCount(null);
        this.togglePopupVisibility(false);
      }
    });
    PixiBase.registerPointerover(popupOkButton, () => {});
    const { x, y, anchor } = this.config.ConnectionPopupContainer.popupOkButton;
    const { anchor: infoTextAnchor } = this.config.ConnectionPopupContainer.popupOkButtonText;

    PixiBase.setPosition(popupOkButton, { x, y });
    this.popupOkButton.anchor.set(anchor);
    this.popupButtonText.anchor.set(infoTextAnchor);
    this.popupOkButton.addChild(popupButtonText);
    this.connectionPopup.addChild(popupOkButton);
  }

  togglePopupVisibility(bool) {
    this.PopupContainer.visible = bool;
    this.isOpenPopup = bool;
    gameStore.setIsGameBackSideOpacity(bool);
  }

  setConnectionLost() {
    PixiBase.changeFrame(this.connectionPopupImg, frameNames.WifiLost);
    this.popupInfoText.visible = true;
    this.popupInfoText.text = gameStore.canvasTranslationKeys.LOST_CONNECTION;
    this.popupOkButton.visible = true;
    this.updateTextStyles(this.popupInfoText, LostConnectionInfoStyles);
  }

  updateTextStyles(text, styles) {
    for (const stylesKey in styles) {
      text.style[stylesKey] = styles[stylesKey];
    }
  }

  changeTextContent(texture, text) {
    texture.text = text;
  }

  setGameOpen() {
    PixiBase.changeFrame(this.connectionPopupImg, frameNames.Shape);
    this.popupInfoText.visible = true;
    this.popupInfoText.text = gameStore.canvasTranslationKeys.TWO_DEVICE_ENTRANCE;
    this.popupInfoText.style.fontSize =
      18 * Math.min((this.connectionPopupTexture.width - 40) / this.popupInfoText.width, 1);
    this.updateTextStyles(this.popupInfoText, GameOpenInfoStyles);
    this.popupOkButton.visible = true;
  }

  setReconnectAnimation() {
    let imgAnimationStep = 1;
    this.popupInfoText.visible = true;
    this.popupInfoText.text = gameStore.canvasTranslationKeys.RECONNECTING;
    this.updateTextStyles(this.popupInfoText, ReconnectInfoStyles.text2);
    this.intervalId = setInterval(() => {
      PixiBase.changeFrame(
        this.connectionPopupImg,
        imgAnimationStep % 2 ? frameNames.Reconnect : frameNames.Reconnect2
      );
      imgAnimationStep += 1;
    }, 500);
    this.popupOkButton.visible = false;
  }

  setInsufficientAmount() {
    this.isLowBalance = true;
    PixiBase.changeFrame(this.connectionPopupImg, frameNames.Shape);
    this.popupInfoText.visible = true;
    this.popupInfoText.text = gameStore.canvasTranslationKeys.INSUFFICIENT_FUNDS;
    this.popupInfoText.style.fontSize =
      18 * Math.min((this.connectionPopupTexture.width - 40) / this.popupInfoText.width, 1);
    this.updateTextStyles(this.popupInfoText, GameOpenInfoStyles);
    this.popupOkButton.visible = true;
  }

  visibilityChangeHandler = () => {
    const state = document.visibilityState;
    if (state === 'hidden') {
      this.visibilityStartTime = Date.now();
    } else if (Date.now() - this.visibilityStartTime > MAX_USER_INACTIVE_STATE_DURATION) {
      this.togglePopupVisibility(true);
      this.setSessionOver();
    }
  };

  setSessionOver() {
    PixiBase.changeFrame(this.connectionPopupImg, frameNames.Shape);
    this.popupInfoText.visible = true;
    this.popupInfoText.text = gameStore.canvasTranslationKeys.SESSION_INACTIVITY;
    this.popupInfoText.style.fontSize =
      18 * Math.min((this.connectionPopupTexture.width - 40) / this.popupInfoText.width, 1);
    this.updateTextStyles(this.popupInfoText, GameOpenInfoStyles);
    this.popupOkButton.visible = true;
  }

  clearReconnectAnimation() {
    clearInterval(this.intervalId);
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.createPopupBackGround();
    this.createPopupBackGroundGraphics();
    this.createPopupInfoImg();
    this.createPopupInfoText();
    this.createPopupOkButton();
  }
}
